export var defaultFormData = {
  applicationId: '',
  // 所属应用id
  applicationName: '',
  // 所属应用名称
  cashInitUserNum: 0,
  // 提现初始人数
  cashLimitDaily: 0,
  // 每日提现人数上限
  popupId: '',
  // 客服id
  popupDes: '',
  // 客服按钮文案
  autoAuditEnabled: 0,
  // 关闭微信提现自动审核
  autoAuditPrice: 0,
  // 微信提现自动审核阈值
  alipayAutoAuditEnabled: 0,
  // 关闭支付宝提现自动审核
  alipayAutoAuditPrice: 0,
  // 支付宝提现自动审核阈值
  cashDes: '' // 提现说明
};
export var formRules = {
  applicationId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择所属应用'
  }],
  cashInitUserNum: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入提现初始人数'
  }],
  cashLimitDaily: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入每日提现人数上限'
  }],
  // wechatPublicAppid: [{ required: true, trigger: ['blur', 'change'], message: '请输入提现公众号APPID' }],
  // wechatPublicAppSecret: [{ required: true, trigger: ['blur', 'change'], message: '请输入提现公众号密钥' }],
  popupId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择客服'
  }],
  popupDes: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写客服按钮文案'
  }],
  autoAuditEnabled: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择微信自动审核开关'
  }],
  alipayAutoAuditEnabled: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择支付宝自动审核开关'
  }],
  cashDes: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写提现说明'
  }]
};